import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

import { DocPackageVendor, DocutechGlobalModel } from '../../models/docutech-global.model';

function createInitialState(): DocutechGlobalModel {
  return <DocutechGlobalModel>{
    canPreviewDisclosure: false,
    canOrderDisclosure: false,
    isDisclosuresResolution: false,
    docPackageVendor: DocPackageVendor.Docutech,
    previewRequestId: null,
    orderRequestId: null,
    deliveryMethod: null,
    rulesetDisposition: null,
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'docutech-global-store' })
export class DocutechGlobalStore extends Store<DocutechGlobalModel> {
  constructor() {
    super(createInitialState());
  }
}
